<template>
  <div class="Details">
    
    <div class="columns">
        
        <div class="column">
          
     <section ref="element">
     
        <div class="x">

           <b-skeleton size="is-large" height="80px" :active="!filteredRows"></b-skeleton>
           <b-skeleton size="is-large" height="160px" :active="!filteredRows"></b-skeleton>
           
           
           <div class="box">
            
            <b-field class="control" grouped>
                <b-dropdown aria-role="list" 
                    style="padding: 0px 5px 0px 0px;"
                    animation
                    class="" :triggers="['click']"
                    :can-close="['outside']"
                    :close-on-click="false">
                        <template #trigger="{ active }">
                            <b-tooltip type="is-dark" position="is-bottom" multilined>
                                
                            <b-button
                            
                            type="is-whitex"
                            >
                                <i class="fa fa-filter"></i>
                            </b-button>
                <template v-slot:content>
                    <span>
                        Filter the most relevant records
                    </span>
                </template>
                </b-tooltip>
                            
                        </template>
                        <b-dropdown-item expanded>
                            
                            <b-field label="Predictions" message="Filter predictions">
                    <b-select
                       @input="changeFilter"
                       v-model="predicted"
                       placeholder="Predictions"
                       expanded>
                       <option value="any">Any</option>
                       <option value="agrees">Predicted agrees</option>
                       <option value="disagrees">Predicted disagrees</option>
                       <option value="not">Not predicted</option>
                       <optgroup label="Predicted as" >
                          <option
                             v-for="(option, idx) in project.labels"
                             :value="project.labels[idx].label"
                             >
                             {{ project.labels[idx].label }}
                          </option>
                       </optgroup>
                    </b-select>
                 </b-field>
                </b-dropdown-item>
                 <b-dropdown-item expanded>
                 <b-field label="Labels">
                    <b-select
                       @input="changeFilter"
                       v-model="given"
                       placeholder="Labels"
                       expanded>
                       <option value="any">Any</option>
                       <option value="unlabeled" selected>Unlabeled</option>
                       <optgroup label="Labeled as" >
                          <option
                             v-for="(option, idx) in project.labels"
                             :value="project.labels[idx].label"
                             >
                             {{ project.labels[idx].label }}
                          </option>
                       </optgroup>
                    </b-select>
                 </b-field>
                </b-dropdown-item>
                 <b-dropdown-item expanded>
                            <b-field label="Upload">
                                <b-select
                                
                                @input="changeFilter"
                                v-model="filterByDataset"
                                placeholder="Filter by source file"
                                expanded>
                                <option value="any">Any</option>
                                <option value="API">API</option>
                                <option
                                    v-for="dataset in projectUploads"
                                    :value="dataset.id"
                                    >
                                    {{ dataset.filename }}
                                </option>
                                </b-select>
                            </b-field> 
                        </b-dropdown-item>
                    </b-dropdown>
                <b-input 
                       expanded 
                       placeholder="🔎  Search records by text or id"
                       v-model="search"
                       @input="changeFilter"
                       icon-right-clickable
                       @icon-right-click="search = null"
                       type="search" />
                       
            
                       <b-field class="" style="padding: 0px 1px 0px 5px;">
                        <p class="control">
                    <b-dropdown aria-role="list" 
                    expanded
                    class="" :triggers="['click']"
                    :can-close="['outside']"
                    :close-on-click="false">
                        <template #trigger="{ active }">
                            <b-tooltip type="is-dark" position="is-bottom" multilined>
                                <b-button
                            type="is-whitex"
                            >
                                <i class="fa fa-sort"></i>
                            </b-button>
                <template v-slot:content>
                    <span>
                        Sort records
                    </span>
                </template>
                </b-tooltip>
                            
                            
                        </template>
                        <b-dropdown-item expanded>
                            <b-field label="Confidence score">
                    <b-select
                       @input="changeFilter"
                       v-model="sortBy"
                       placeholder="Confidence"
                       expanded>
                       <option value="high_score">Highest score</option>
                       <option value="low_score">Lowest score</option>
                    </b-select>
                    </b-field>
                    </b-dropdown-item>
                    <b-dropdown-item expanded>
                    <b-field label="Upload date">
                    <b-select
                       @input="changeFilter"
                       v-model="sortBy2"
                       placeholder="Record"
                       expanded>
                       <option value="most_recent">Most recent</option>
                       <option value="least_recent">Least recent</option>
                    </b-select>
                    </b-field>
                    </b-dropdown-item>
                    </b-dropdown>
                    </p>
                 </b-field>
                 <b-field position="is-right">
                    <p class="control">
                    
                    <b-tooltip type="is-dark" position="is-bottom" multilined>
                        <b-button
                        @click="isModalUploadOpen = true"
                        type="is-whitex">
                        <i class="fa fa-upload"></i>
                    </b-button>
                    <template v-slot:content>
                        <span>
                            Upload dataset from CSV, PDF or API
                        </span>
                    </template>
                    </b-tooltip>
                    
                    </p>
            <p class="control">
                
                <b-tooltip type="is-dark" position="is-bottom" multilined>
                    <b-button
                        @click="isModalLabelsOpen = true"
                        type="is-whitex">
                        <i class="fa fa-tags"></i>
                    </b-button>
                <template v-slot:content>
                    <span>
                        Add or edit your labels
                    </span>
                </template>
                </b-tooltip>
            </p>
            <p class="control">
                <b-tooltip type="is-dark" position="is-bottom" multilined>
                    <b-button @click="isModalAutoLabelOpen = true" :loading="isAutoLabelRunning()" :disabled="isAutoLabelRunning()">
                    <svg xmlns="http://www.w3.org/2000/svg" height="11" width="13" viewBox="0 0 576 512"><path d="M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"/></svg>
                </b-button>
                <template v-slot:content>
                    <span v-if="isAutoLabelRunning()">
                        <b>Auto-label</b> is running
                    </span>
                    <span v-else>
                        Automatically label your data
                    </span>
                </template>
                </b-tooltip>
                
            </p>
                </b-field>
                

            </b-field>

            <!-- <b-field grouped group-multiline class="columns">
              <div class="column is-half">
                <div class="columns is-pulled-left">    
                    
                <b-field class="control column is-12 is-gapless">
                 
                    <b-input expanded 
                       @input="changeFilter"
                       type="search"
                       v-model="search"
                       class="input" 
                       placeholder="🔎  Search a text or record id"
                       icon-right-clickable
                       @icon-right-click="search = null" />
                 
                 <b-button type="">
                        <i class="fa fa-filter"></i>
                        Filters
                </b-button>
                 
              </b-field>
              </div>
              </div>
              <div class="column is-half">
              <div class="columns is-pulled-right">
              <b-field grouped group-multiline class="column is-gapless">
              <b-field>
                    <b-dropdown aria-role="list" 
                    animation
                    
                    class="" :triggers="['click']"
                    :can-close="['outside']"
                    :close-on-click="false">
                        <template #trigger="{ active }">
                            <b-button
                                type="">
                                <i class="fa fa-eye"></i>
                                View
                            </b-button>
                            
                        </template>
                        <b-dropdown-item expanded>
                            <b-field label="Annotation" message="Switch to AI assistance annotation">
                                <b-switch v-model="annotationMode" type="is-info" @input="enableAnnotationMode()">
                                    <span v-if="annotationMode"><b>Annotation Mode</b></span>
                                    <span v-else>Annotation Mode</span>
                                </b-switch>
                            </b-field>
                        </b-dropdown-item>
                    </b-dropdown>
                </b-field>
                
                
                </b-field>
            </div>
            </div>
              </b-field> -->
              <b-field grouped group-multiline>
                    <div class="control" v-if="annotationMode != false">
                        <b-tag type="is-info" closeType='is-info' closable @close="annotationMode = false" attached aria-close-label="Close tag">
                        Annotation mode enabled
                        </b-tag>
                    </div>
                    <div class="control" v-if="filterByDataset != 'any'">
                        <b-tag type="is-light" closeType='is-light' :closable="filterByDataset != 'any'" @close="filterByDataset = 'any'" attached aria-close-label="Close tag">
                        Filter by Upload = {{ filterByDataset == 'API' ? 'API' : projectUploads.filter( i => i.id == filterByDataset)[0].filename }} 
                        </b-tag>
                    </div>
                    <div class="control" v-if="predicted != 'any'">
                        <b-tag type="is-light" :closable="predicted != 'any'" @close="predicted = 'any'" @click="changeFilter" attached aria-close-label="Close tag"
                        >Predicted = {{ predicted }}
                        </b-tag>
                    </div>
                    <div class="control" v-if="sortBy != null">
                        <b-tag type="is-light" :closable="sortBy != null" @close="sortBy = null" @click="changeFilter" attached aria-close-label="Close tag"
                        >Sort by = {{ sortBy | capitalize }}
                        </b-tag>
                    </div>
                    <div class="control" v-if="sortBy2 != null">
                        <b-tag type="is-light" :closable="sortBy2 != null" @close="sortBy2 = null" @click="changeFilter" attached aria-close-label="Close tag"
                        >Sort by = {{ sortBy2 | capitalize }}
                        </b-tag>
                    </div>

                    <div class="control" v-if="given != 'any'">
                        <b-tag type="is-light" :closable="given != 'any'" @close="given = 'any'" @click="changeFilter" attached aria-close-label="Close tag"
                    >
                    Labeled = {{ given }}
                </b-tag>
                    </div>

                </b-field>
              
              
              <div class="buttons" style="margin-bottom: 0.1em;color: gray" v-if="true">
                <span v-if="false">
                    <b-button @click="isModalPatternsOpen = true" class="button" size="is-small" type="is-white is-light">
                        <span class="icon">
                        <i class="fa fa-plus"></i>
                        </span>
                        &nbsp;Create a pattern for "{{ search }}" ({{ filteredRows.length }})
                    </b-button>
                </span>
                <span v-else-if="selectedRecords.length > 0">
                    <b-button class="button" size="is-small" type="is-success is-light">
                        <span class="icon">
                        <i class="fa fa-check"></i>
                        </span>
                        &nbsp;Validate ({{ selectedRecords.length }})
                    </b-button>
                    <b-button class="button" size="is-small" type="is-warning is-light">
                        <span class="icon">
                        <i class="fa fa-ban"></i>
                        </span>
                        &nbsp;Skip ({{ selectedRecords.length }})
                    </b-button>
                    <b-button class="button" size="is-small" type="is-danger is-light">
                        <span class="icon">
                        <i class="fa fa-times"></i>
                        </span>
                        &nbsp;Delete ({{ selectedRecords.length }})
                    </b-button>
                    <b-dropdown aria-role="list">
                        <template #trigger="{ active }">
                            <b-button
                                size="is-small"
                                type="is-info is-light"
                                :icon-right="active ? 'menu-up' : 'menu-down'">
                                <span class="icon">
                                <i class="fa fa-arrow-right"></i>
                                </span>
                                &nbsp;Annotate to a label ({{ selectedRecords.length }})
                            </b-button>
                        </template>
                        <b-dropdown-item aria-role="listitem">Action</b-dropdown-item>
                        <b-dropdown-item aria-role="listitem">Another action</b-dropdown-item>
                        <b-dropdown-item aria-role="listitem">Something else</b-dropdown-item>
                    </b-dropdown>
                    &nbsp;
                    <b-button class="button" size="is-small" type="is-white is-light" @click="selectedRecords = []">
                        <span class="icon">
                        <i class="fa fa-times"></i>
                        </span>
                        &nbsp;Erase Selection
                    </b-button>
                </span>
              </div>
              
              <div v-if="rows.length < 1">
                <h4 class="title is-4 mt-6 pt-2 has-text-centered">
                    💡 Tip: Get better results by adding training samples
                </h4>
                <h4 class="title is-5 mt-6 has-text-centered">
                    Upload dataset from CSV, PDF or API
                </h4>
                <p class="subtitle is-6 has-text-centered">
                    <b-button
                        @click="isModalUploadOpen = true"
                        size="is-large">
                        <i class="fa fa-upload"></i>
                    </b-button>
                </p>
                
                <h4 class="title is-5 mt-6 has-text-centered">
                    <i class="fa fa-tags"></i> Add or edit your labels
                </h4>
                <p class="subtitle is-6 has-text-centered">
                     Define the labels you want to predict
                </p>
                
              </div>
              
              <b-table 
                 v-else
                 :data="filteredRows"
                 :per-page="annotationMode?1:30"
                 :current-page.sync="currentPage"
                 :total="filteredRows.length"
                 pagination-position="both"
                 paginated
                 pagination-size="is-small"
                 :loading="!filteredRows || isLoading"
                 >
                 <template #top-left>
                    <b>Records</b>: {{ filteredRows.length }}
                    <b-button
                        @click="refreshRows"
                        type="is-white">
                        <svg xmlns="http://www.w3.org/2000/svg" height="0.8em" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H336c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32s-32 14.3-32 32v51.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V448c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H176c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"/></svg>
                        
                    </b-button> 
                  </template>
                  <b-table-column width="100" field="text" label="" v-slot="props" v-if="project.type == 'classification'" >
                        <RecordsClassify :key="props.row.id" :train="true" :row="props.row" :project="project"></RecordsClassify>
                  </b-table-column>
                  <b-table-column width="100" field="text" label="" v-slot="props" v-else-if="project.type == 'extraction'">
                        <RecordsExtract :key="props.row.id" :train="true" :row="props.row" :project="project" :currentOrg="currentOrg" :currentUser="currentUser"></RecordsExtract>
                  </b-table-column>
                  <!-- <b-table-column width="100" field="text" label="" v-slot="props" v-else>
                        <RecordsClassify @close="props.close" :train="true" :row="props.row" :project="project" :currentOrg="currentOrg" :currentUser="currentUser"></RecordsClassify>
                  </b-table-column> -->
                  <!-- Annotation mode controls -->
                  <template #footer v-if="annotationMode">
                    <div class="buttons is-centered">
                        <!-- <b-button type="is-success">
                            <span class="icon">
                            <i class="fa fa-check"></i>
                            </span>
                            Accept
                            <span class="labelCode">
                                Press A
                            </span>
                        </b-button> -->

                        <!-- <b-button type="is-light">
                            <span class="icon">
                            <i class="fa fa-ban"></i>
                            </span>
                            Skip
                            <span class="labelCode">
                                Press S
                            </span>
                        </b-button> -->

                        <b-button type="is-primary" @click="nextPage()">
                            <span class="icon">
                            <i class="fa fa-arrow-right"></i>
                            </span>
                            Next record
                            <span class="labelCode">
                                Press N
                            </span>
                        </b-button>
                    </div>
                  </template>
                 <template #bottom-left v-if="annotationMode">
                        <b>Annotated records: {{ filteredRows.filter( i => i.label !== null).length }} out of {{ filteredRows.length }}</b>
                 </template>
                  
              </b-table>
              <hr>
           </div>
        </div>
     </section>
     
        </div>
        

        <div class="column is-3 model-menu" v-if="showViewModels || tabId == 'models'">
            <b-skeleton size="is-large" height="120px" :active="!projectModels"></b-skeleton>
            <div v-if="currentModel">
                <!-- model trained -->
                <!-- list models -->
                <b-field :label="`Models (${projectModels.length})`" :message="currentModel ? 'ID '+currentModel.id : ''">
                    <b-select 
                        :class="currentModel && currentModel.state.status == 'error' ? 'is-danger' : ''"
                        :loading="Object.hasOwn(currentModel, 'state') ? !['complete', 'error'].includes(currentModel.state.status) : false"
                        v-model="currentModel"
                        placeholder="Select a model version"
                        expanded>
                        <option :value="model" :selected="project.modelId == model.id" v-for="model, idx in projectModels">
                            {{ model.name || model.id }} | {{ Object.hasOwn(model, 'state') && model.state.status != 'complete' ? trainingStatusMap[model.state.status] : '✅' | capitalize}}
                        </option>
                    </b-select>
                
                </b-field>
                <b-skeleton size="is-large" height="120px" :active="!currentModel"></b-skeleton>
                <div v-if="!['complete', 'error'].includes(currentModel.state.status)">
                    <!-- is training -->
                    <p class="subtitle is-6 has-text-grey" style="margin-top: -0.4em;">
                        <b-tag type="is-info">{{  trainingStatusMap[currentModel.state.status] }}</b-tag>
                    </p>
                    <b-field label="Training">
                    <b-dropdown-item role="router-link" aria-role="listitem">
                                <b-steps
                                    position="left"
                                    label-position="right"
                                    size="is-small"
                                    :has-navigation="false"
                                    v-model="currentModel.state.status"
                                    vertical>
                                    <b-step-item value="queued" :clickable="false" label="Preparing your data" icon="account-key">
                                    </b-step-item>

                                    <b-step-item value="pending" :clickable="false" label="Provisioning GPU" icon="account-key">
                                    </b-step-item>

                                    <b-step-item value="running" :clickable="false" label="Training & learning" icon="account">
                                    </b-step-item>

                                    <b-step-item value="evaluate" :clickable="false" label="Calculating model performance" icon="account-plus">
                                    </b-step-item>
                                </b-steps>
                            </b-dropdown-item>
                    </b-field>
                </div>
                <div v-else>
                    <b-field v-if="project.modelId && currentModel && Object.hasOwn(currentModel, 'state')" style="margin-top: -0.4em;">
                        <p class="subtitle is-7 has-text-grey mt-0">
                                <b-tag v-if="currentModel.state.status == 'error'" type="is-warning" class="mr-1">
                                    
                                    <router-link :to="`/projects/${project.id}/settings/logs`" class="has-text-black">
                                        
                                        <i class="fa fa-exclamation-circle"></i>
                                        
                                    </router-link>
                                    
                                </b-tag>
                                <b-tag type="is-info" class="mr-1">{{ strategyMap[currentModel.strategy] }}</b-tag>
                                <b-tag type="is-info" class="mr-1">{{ currentModel.size | capitalize }}</b-tag>
                                <b-tag type="is-light" class="is-pulled-right">{{ currentModel.createdAt | dateFormat }}</b-tag>
                            </p>
                    </b-field>
                    <b-field control class="buttons">
                        <!-- button as router link-->
                        <b-button tag="router-link" type="is-infox" :to="`/projects/${project.id}/connect`">Connect</b-button>
                        
                        <b-button expanded type="is-info" @click="isModalTestModelOpen = true">
                            <i class="fa fa-play"></i> Predict preview
                        </b-button>
                        
                    </b-field>
                    <hr>
                    <div class="is-pulled-right">
                        <b-tooltip type="is-dark" position="is-left" multilined>
                            
                                <i class="fa fa-info-circle"></i>
                            
                            <template v-slot:content>
                                <span>
                                    <b>F1-score</b> is the harmonic mean of precision and recall.
                                    <br>
                                    <b>Accuracy</b> is the percentage of correct predictions over all.
                                    <br>
                                    <b>Report</b> is a detailed report for model performance on each label.
                                </span>
                            </template>
                        </b-tooltip>
                        </div>
                    <b-field label="Performance" >
                        
                        <div class="columns">
                            <div class="column is-6 is-desktop is-offset-0">
                                <h1 class="title is-3" v-if="currentModel && Object.hasOwn(currentModel, 'model_metrics') && currentModel.model_metrics.f1score >= 0">{{ (parseFloat(String(currentModel.model_metrics.f1score).substring(0, 5)).toFixed(2)*100) }}%</h1>
                                <h1 class="title is-3" v-else>N/A</h1>
                                <h2 class="subtitle">F1-score</h2>
                            </div>
                            <div class="column is-6 is-desktop is-offset-0">
                                <b-tagx type="is-white" size="is-small" class="is-pulled-right">
                                    <h1 class="title is-3" v-if="currentModel && Object.hasOwn(currentModel, 'model_metrics') && currentModel.model_metrics.accuracy >= 0">{{ (parseFloat(String(currentModel.model_metrics.f1score).substring(0, 5)).toFixed(2)*100) }}%</h1>
                                    <h1 class="title is-3" v-else>N/A</h1>
                                    <h2 class="subtitle">Accuracy</h2>
                                </b-tagx>
                            </div>
                        </div>
                        
                    </b-field>
                    <b-button type="is-whitex" size="is-smallx" @click="isModalTrainingMetricsOpen = true">
                        <svg xmlns="http://www.w3.org/2000/svg" height="16" width="14" viewBox="0 0 448 512"><path d="M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"/></svg>
                        Report
                    </b-button>
                    <hr>
                    <div class="is-pulled-right">
                        <b-tooltip type="is-dark" position="is-left" multilined>
                            
                                <i class="fa fa-info-circle"></i>
                            
                            <template v-slot:content>
                                <span>
                                    <b>Correct</b> is the number of records predicted correctly.
                                    <br>
                                    <b>Incorrect</b> is the number of records predicted incorrectly.
                                    <br>
                                    <b>Missed</b> is the number of records that should have been predicted but were not.
                                    <br>
                                    <b>Unlabeled</b> is the number of records that were not labeled.
                                </span>
                            </template>
                        </b-tooltip>
                        </div>
                    <b-field label="Results" message="These results are from the latest model training.">
                        <!-- <b-select
                            v-model="viewFilter"
                            placeholder="Select a view"
                            expanded>
                            <option value="all">All</option>
                            <option value="labeled">Labeled</option>
                            <option value="unlabeled">Unlabeled</option>
                            <option value="issues">Issues</option>
                        </b-select> -->
                    </b-field>
    
        
                    <div class="columns">
                        <div class="column is-10 is-desktop">
                            
                            <b-tagx type="is-white" class="has-text-success" size="is-medium">
                                <span class="icon">
                                    <i class="fa fa-check"></i>
                                </span>
                                <b>Correct predictions</b>
                            </b-tagx>
                        </div>
                        <div class="column is-desktop ">
                            <b-button @click="correctResults = !correctResults" type="is-white" size="is-small" class="is-pulled-right">
                                <span class="icon">
                                    <i v-if="correctResults" class="fa fa-chevron-up fa-2xs"></i>
                                    <i v-if="!correctResults" class="fa fa-chevron-down fa-2xs"></i>
                                </span>
                            </b-button>
                        </div>
                    </div>
                    <!-- white a html table using Bulma style with three columns: label, prediction and count (ordered by count) -->
            
                    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" v-if="correctResults && metrics">
                        <thead>
                            <tr>
                                <th class="has-text-grey">Label</th>
                                <th class="has-text-grey">Correct</th>
                            </tr>
                        </thead>
                        <tbody v-for="(metric, label) in metrics.filter( m => m.correct > 0)">
                            <tr>
                                <td>{{ metric.label }}</td>
                                <td>
                                    <a @click="filterResults(metric.label, metric.label)">
                                    {{ metric.correct }}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
            
                    <div class="columns">
                        <div class="column is-10 is-desktop">
                            <p class="has-text-danger">
                                <span class="icon">
                                    <i class="fa fa-times"></i>
                                </span>
                                <b>Incorrect predictions</b>
                            </p>
                        </div>
                        <div class="column is-desktop">
                            <b-button @click="incorrectResults = !incorrectResults" type="is-white" size="is-small" class="is-pulled-right">
                                <span class="icon">
                                    <i v-if="incorrectResults" class="fa fa-chevron-up fa-2xs"></i>
                                    <i v-if="!incorrectResults" class="fa fa-chevron-down fa-2xs"></i>
                                </span>
                            </b-button>
                        </div>
                    </div>
            
                    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" v-if="incorrectResults && metrics">
                        <thead>
                            <tr class="is-size-6">
                                <th class="has-text-grey">Label</th>
                                <th class="has-text-grey">Missed</th>
                                <th class="has-text-grey">Incorrect</th>
                            </tr>
                        </thead>
                        <tbody v-for="(metric, idx) in metrics.filter( m => m.incorrect > 0 || m.missed > 0)">
                            <tr>
                                <td>{{ metric.label }}</td>
                                <td>
                                    <a @click="filterResults(metric.label, 'not')">
                                    {{ metric.missed }}
                                    </a>
                                </td>
                                <td>
                                    <a @click="filterResults(metric.label, 'disagrees')">
                                    {{ metric.incorrect }}
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-if="metrics.filter( m => m.unlabeled > 0)[0]">
                            <tr>
                                <td>Unlabeled</td>
                                <td>
                                    <a @click="filterResults('unlabeled', 'any')">
                                    {{ metrics.filter( m => m.unlabeled > 0)[0].unlabeled }}
                                    </a>
                                </td>
                                <td>
                                    <a @click="filterResults('unlabeled', 'not')">
                                    0
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
        
            </div>
            <div v-else-if="project.modelId">
                <!-- no model trained -->
                <b-field label="Loading models..." >
                    <b-skeleton size="is-large" height="100px"></b-skeleton>
                    <br><br>
                    <b-skeleton size="is-large" height="220px"></b-skeleton>
                    <br><br>
                    <b-skeleton size="is-large" height="50px"></b-skeleton>
                </b-field>
            </div>
            <div v-else>
                <!-- no model trained -->
                <b-field label="No model trained" >
                    Train a model first to see the results
                </b-field>
            </div>
        </div>
    </div>

    <b-modal
          v-model="isModalTestModelOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Project"
          aria-modal  
          can-cancel
          scroll="keep">
          <template #default="props">
             <ModelTest @close="props.close" :currentUser="currentUser" :project="project" :modelId="currentModel.id"></ModelTest>
          </template>
       </b-modal>

     <b-modal
          v-model="isModalLabelsOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <div class="modal-card box" style="min-width: 60em; width: auto">
                <div class="modal-card-body">
                    <!-- <h3 class="title is-3">
                        Add labels
                    </h3> -->
                    <Labels :project="project" :records="rows" :currentUser="currentUser"/>
                </div>
            </div>
          </template>
      </b-modal>

      <b-modal
          v-model="isModalTrainingMetricsOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Project"
          aria-modal  
          can-cancel
          scroll="keep">
          <template #default="props">
             <TrainingMetrics @close="props.close" :modelId="project.modelId"></TrainingMetrics>
          </template>
       </b-modal>

      <b-modal
          v-model="isModalUploadOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <div class="modal-card box" style="min-width: 60em; min-height: 10em; width: auto">
                <div class="modal-card-body">
                    <!-- <h3 class="title is-3">
                        Add texts
                    </h3> -->
                    <Uploads :project="project" :projectDatasets="projectDatasets" :currentUser="currentUser" :rows="filteredRows"/>
                </div>
            </div>
          </template>
      </b-modal>

      <b-modal
          v-model="isModalAutoLabelOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="false"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <AutoLabel @close="props.close" :project="project" :rows="rows"></AutoLabel>
          </template>
      </b-modal>

      <b-modal
          v-model="isModalPatternsOpen"
          has-modal-card
          trap-focus
          :destroy-on-hide="false"
          aria-role="dialog"
          aria-label="Model"
          aria-modal
          scroll="keep">
          <template #default="props">
            <Patterns @close="props.close" :search="search"></Patterns>
          </template>
      </b-modal>
  </div>
</template>
<script>
  import TrainModel from '@/components/TrainModel.vue'
  import TrainRuns from '@/components/TrainRuns.vue'
  import TrainingMetrics from "@/dashboard/Model/Training.vue";
    // import ModelCreate from "@/components/ModelCreate.vue";
  import ModelTest from "@/components/ModelTest.vue";
  import ModalLabels from '@/components/ModalLabels.vue'
  import Annotation from '@/components/AnnotationTemplateNER.vue'
  import Patterns from '@/components/Patterns.vue'
  import AutoLabel from '@/components/AutoLabel.vue'
  import AnnotationExtraction from '@/components/AnnotationTemplate.vue'
  import Try from '@/components/ProjectCreateTry.vue'
  import Uploads from "@/dashboard/Project/Uploads.vue";
  import Labels from "@/dashboard/Project/Labels.vue";
  import RecordsClassify from "@/dashboard/Project/Records.vue";
  import RecordsExtract from "@/dashboard/Project/RecordsNER.vue";
  import fuzzysort from 'fuzzysort'
  import { mapState } from 'vuex';
  import { timeout } from 'q';

  export default {
       props: ["project", "projectModels", "projectDatasets", "currentUser", "currentOrg", "viewModels", "tabId"],
       name: "Train",
       data: function() {
      return {
          perPage: 10,
          currentPage: 1,
          pageInput: 1,
          annotationMode: false,
          isMounting: true,
          checkedRows: [],
          correctResults: true,
          incorrectResults: true,
          isModalLabelsOpen: false,
          isModalPatternsOpen: false,
          isModalAutoLabelOpen: false,
          isModalUploadOpen: false,
          isModalTestModelOpen: false,
          isModalTrainingMetricsOpen: false,
          viewFilter: (this.$route.query.f == 'errors')?'issues':'all',
          viewOptions: ['all', 'labeled', 'unlabeled', 'issues'],
          versions: false,
          checkboxCustom: [],
          selected: {text: false, label: 'unlabeled'},
          newLabel: false,
          selectedVersion: 'v1',
          animated: true,
          candidateLabels: [(1,1),(2,3)],
          isModalTrainCreateOpen: false,
          labelKeys: [],
          options: {
          
          },
          total: 0,
          predicted: 'any',
          given: 'any',
          search: null,
          sortBy: null,
          sortBy2: 'most_recent',
          filterByDataset: 'any',
          uploadList: [],
          labelsViewMin: 10,
          selectedRecords: [],
          project_labels: this.project.labels.map(({ label }) => label),
          currentModel: [],
          trainingStatusMap: {
            queued: 'In Progress',
            pending: 'In Progress',
            running: 'In Progress',
            evaluate: 'In Progress',
            complete: 'Complete',
            error: 'Error'
          },
          strategyMap: {
            'llm-prompt': 'Few-Shot',
            'fine-tune': 'Fine-Tune',
          }
      }},
      components: {
        "modal-train": TrainModel,
        "train-runs": TrainRuns,
        Try,
        ModalLabels,
        Annotation,
        Patterns,
        AnnotationExtraction,
        Uploads,
        Labels,
        RecordsClassify,
        RecordsExtract,
        ModelTest,
        TrainingMetrics,
        AutoLabel
      },
     
      computed: {
        metrics() {
            return this.$store.getters.progressMetrics(this.project.datasetId)
        },
        projectModels(){
            return this.$store.state.projectModels
        },
        showViewModels(){
            return this.$store.state.viewModels
        },
        projectUploads(){
            return this.$store.state.projectUploads;
        },
        isLoading(){
            return this.$store.getters.isLoading
        },
       rows() {
            return this.$store.getters.rowsByDataset(this.project.datasetId)
       },
       filteredRows() {
        return this.sortRows(
              this.fuzzySearchFilter(
                this.$store.getters.rowsByDataset(this.project.datasetId).filter( 
                  item => (
                    this.givenFilter(item) && this.predictedFilter(item) && this.datasetFilter(item)
                  )
                )
              )
            )
        } 
       },
       filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            value = value.replace('_', ' ')
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        dateFormat: function (d) {
            return d.toDate().toLocaleString('en-US', 
            { timeZone: 'UTC', hour: 'numeric', minute: 'numeric', day: 'numeric', month: 'numeric', year: 'numeric' })
        }
       },
       watch: {
        project: function(){
            this.$store.dispatch("projectModels", this.project.id).then( () => {
                this.getCurrentModel(this.project.modelId)
            })
        },
        projectModels: function(){
            this.getCurrentModel(this.project.modelId)
        },
       },
       methods: {
        isAutoLabelRunning(){
            let hasStatus = Object.hasOwn(this.project, 'state') && Object.hasOwn(this.project.state, 'label') && Object.hasOwn(this.project.state.label, 'status')
            return hasStatus && this.project.state.label.status == 'running'
        },
        filterResults(label, prediction){
            this.predicted = prediction
            this.given = label
        },
        refreshRows(){
            this.$store.dispatch('getRowsByDataset', this.project.datasetId)
        },
        selectRow(row){
            if (!this.selectedRecords.includes(row.id)){
                this.selectedRecords.push(row.id)
            } else {
                const idx = this.selectedRecords.indexOf(row.id);
                this.selectedRecords.splice(idx, 1);
            }
        },
        isJsonString(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
          },
        nextPage(){
            let totalRows = this.rows.length
            this.currentPage = this.currentPage + 1
            console.log(this.currentPage, totalRows)
        },
        triggerTraining(){
            this.$store.dispatch("triggerTraining",
                    {projectId: this.project.id}
            )
        },
        isLabelEmply(row){
            if (!Array.isArray(row.labels)) return true;
            if (row.labels.length < 1) return true;
            else return false;
        },
        isPredictedEmpty(prediction){
            if (!Array.isArray(prediction)) return true;
            if (prediction.length < 1) return true;
            else return false;
        },
        isSuggestionEmply(row){
            if (!Array.isArray(row.suggestion)) return true;
            if (row.suggestion.length < 1) return true;
            else return false;
        },
        isPredictedCorrectly(prediction, labels){
            // -1: no predicted, 0, wrong, 1: correctly
            // check if row.prediction is array type
            if (!Array.isArray(prediction)) return -1;
            else if (!Array.isArray(labels)) return -1;
            else if (prediction.length < 1) return -1;
            else if (
                !prediction.every( pred => labels.includes(pred) )
                && 
                !labels.every( label => prediction.includes(label) )
            ) return 0
            else if (labels == prediction) return 1
            else return (
                prediction.every( pred => labels.includes(pred) )
                && 
                labels.every( label => prediction.includes(label) )
            )
            // else if (row.labels.every( label => row.prediction.includes(label) )) return true
            // else return false
        },
        changeFilter(){
            //   this.documents = this.getDocuments()
        },
        getLabels(){
          return (this.project.labels?this.project.labels:[])
        },
        predictedFilter(item){
            let prediction = Array.isArray(item.prediction) ? item.prediction : []
            let labels = Array.isArray(item.labels) ? item.labels : []
            let tags = Array.isArray(item.tags) ? item.tags : []
            if (this.project.type == 'extraction'){
                if (this.predicted == 'agrees'){
                    return item.prediction.filter( p => tags.filter( t => t.text == p.text && t.label == p.label).length > 0 ).length > 0
                } else if (this.predicted == 'disagrees'){
                    return item.prediction.filter( p => tags.filter( t => t.label == p.label).length == 0 ).length > 0
                }

                prediction = Array.isArray(prediction) ? prediction.filter(i => i.text != null && i.text.length > 0).map(({label}) => label) : []
                labels = Array.isArray(tags) ? tags.map(({label}) => label) : []
            }

            if (this.predicted == 'not'){
            return this.isPredictedEmpty(prediction)
            } else if (this.predicted == 'agrees'){
            return this.isPredictedCorrectly(prediction, labels) == true
            } else if (this.predicted == 'disagrees'){
            return this.isPredictedCorrectly(prediction, labels) == false
            }  else if (this.predicted != 'any'){
            return prediction.includes(this.predicted)
            } else if (this.predicted == 'any'){
            return true
            } else {
            return false
            }
        },
        validLabels(record_labels){
            if (!this.project.labels) return false;
            if (!record_labels) return false;
            let project_labels = this.project.labels.map(({ label }) => label)
            return project_labels.some( label => record_labels.includes(label) );
        },
        validRecordLabels(record_labels){
            if (!record_labels) return false;
            return Array.isArray(record_labels) && record_labels.length > 0
        },
        validLabelsIncludes(labels, given){
            if (!this.validRecordLabels(labels)) return false;
            else {
                return labels.includes(given)
            }
        },
        givenFilter(item){
          let labels = item.labels
          if (this.project.type == 'extraction')
            labels = Array.isArray(item.tags) ? item.tags.map(({label}) => label) : []
        
          let is_labeled = this.validRecordLabels(labels || [])
          let is_valid_labels = this.validLabels(labels || [])
          let is_label_contains = this.validLabelsIncludes(labels, this.given)
          
          if (this.given === 'unlabeled'){
            return  (!is_valid_labels || !is_labeled) || labels === undefined || labels === false || labels == null || labels === 'False' || labels === undefined
          } else if (this.given != 'any'){
            return is_label_contains
          } else if (this.given === 'any'){
            return true
          } else {
            return false
          }
        },
        fuzzySearchFilter(docs){
           const options = {
               key: 'text',
               limit: 200, // don't return more results than you need!
               threshold: -10000, // don't return bad results
            }
            const recordId = "021d268f7761f169d8df8b78243d69ea"
            
            if (this.search != null && this.search != ""){
                let search = this.search.trim()    
                const isSearchId = search.length === recordId.length
                
                if (isSearchId){
                    return docs.filter(i => search == i.id)
                }
                // const isLabel = this.project.labels.map( l => {l.label}).includes(search)
                // if (isLabel){
                //     return docs.filter(i => i.labels.includes(search) )
                // }

                return fuzzysort.go(search, docs, options).flatMap(r => r.obj)
            } else {
               return docs
            }
        },
        datasetFilter(item){
          if (this.filterByDataset !== 'any'){
            return item.uploadId === this.filterByDataset
          } else {
            return true
          }
        },
        sortRows(doc){
          // most_recent_added, most_recent_annotated,  
          
          if (this.sortBy2 == 'least_recent'){
            doc = doc.sort((a,b) => a.createdAt - b.createdAt);
          } else {
            doc = doc.sort((a,b) => b.createdAt - a.createdAt);
          }
          
          if (this.sortBy == 'high_score'){
            return doc.sort((a,b) => b.confidence - a.confidence);
          } else if (this.sortBy == 'low_score'){
            return doc.sort((a,b) => a.confidence - b.confidence);
          } else {
            return doc
          }
        },
        getCurrentModel(modelId){
            if (this.projectModels)
                this.currentModel = this.projectModels.filter( i => i.id == modelId)[0]
        },
       },
        mounted() {
            this.$store.dispatch("projectModels", this.project.id).then( () => {
                this.getCurrentModel(this.project.modelId)
            })
            if (this.project.modelId){
                this.getCurrentModel(this.project.modelId)
            }
            this.$store.dispatch("projectUploads", this.project.datasetId)

            console.log("isLoading", this.isLoading)
            this.isMounting = false
            
            this.project_labels = this.project.labels.map(({ label }) => label)
            // const labelKeys = ['Digit1', 'Digit2', 'Digit3', 'Digit4', 'Digit5', 'Digit6', 'Digit7', 'Digit8', 'Digit9', 'Digit0']
            // window.addEventListener("keypress", e => {
                
            //     if (["KeyN","KeyC"].includes(e.code) && this.annotationMode){
            //         this.nextPage()
            //     }
                
            //     else if (["KeyA"].includes(e.code) && this.annotationMode){
            //         let prediction = this.filteredRows[this.currentPage-1].prediction
            //         if (prediction && this.filteredRows.length == 1){
            //             this.filteredRows[this.currentPage-1].label = prediction
            //             this.changeOutput(this.filteredRows[this.currentPage-1], true)
            //         }
            //     }
                
            //     else if (labelKeys.includes(e.code) && this.annotationMode) {
            //         let labels = this.getLabels()
            //         let idx = parseInt(e.code.slice(-1))-1

            //         let c = labels[idx]
            //         this.filteredRows[this.currentPage-1].label = c.label
            //         this.changeOutput(this.filteredRows[this.currentPage-1], true)
            //     }
                
            // });

       }, created() {
            if (this.project.modelId){
                this.getCurrentModel(this.project.modelId)
            }

       }
     };
</script>
<style lang="scss" scoped>

.model-menu {
    animation:navAnimOpen 0.7s slide-left both;
}

.slide-left{animation:slide-left .5s cubic-bezier(.25,.46,.45,.94) both}

@keyframes navAnimOpen {
  0% {display: none;opacity: 0;max-height: 0;}
  2% {display: block;opacity: 0;}
  100% {opacity: 1;max-height: 396px;}
}

.vertical {
  height: 500px;/*Altura da linha*/
  border-left: 2px solid;/* Adiciona borda esquerda na div como ser fosse uma linha.*/
}

.no-active:focus {
    outline:none;
}
  .boards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  .board {
  cursor: pointer;
  border: solid 1px #e6e4e4;
  border-radius: 4px;
  &:hover {
  background: #fafafa;
  }
  .info {
  padding: 16px;
  .name {
  display: block;
  margin-bottom: 8px;
  text-transform: capitalize;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  }
  .description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin: 0;
  margin-bottom: 8px;
  overflow: hidden;
  }
  }
  }
  }


.labelCode {
  position: absolute; /* Set the span's position to absolute */
  bottom: 0; /* Align the span to the bottom */
  left: 50%; /* Align the span horizontally */
  transform: translateX(-50%); /* Center the span horizontally */
  font-size: 9px; /* Set the font size of the span */
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}


</style>    
